/**
 * 英语（en）
 */

export default {
  // 刊登编辑页面 edit
  publishEdit: {
    listings: 'Listings',
    Platform: 'Platform',
    Store: 'Store',
    ProductTitle: 'Product Title',
    Tags: 'Tags',
    Custom: 'Custom',
    Collections: 'Collections',
    Category: 'Category',
    Description: 'Description',
    Variants: 'Variants',
    Images: 'Images',
    listNow: 'List Now',
    CancelEditing: 'Cancel Editing',
    tips1: 'No more than 40000 characters',
    tips2: 'Only JPG, JPEG and PNG images are supported.',
    ShippingMethod: 'Shipping Method',
    Product: 'Product',
    SKU: 'SKU',
    size: 'Size',
    color: 'Color',
    ProductCost: 'Product Cost',
    ShippingCost: 'Shipping Cost',
    CompareAtPrice: 'Compare At Price',
    SuggestedPrice: 'Suggested Price',
    Profi: 'Profit',
    Quantity: 'Quantity',
    WarehouseName: 'Warehouse Name',
    tips3: 'Including Shipping Cost',
    tips4: ' Supports a maximum of 250 images',
    tips5: ' Supports a maximum of 40 images',
    SuggestedPriceTips1: 'Suggested Price=Product Cost * (1+Profit Margin)+Shipping Cost',
    CompareAtPriceTips1: 'Compare At Price=Product Cost * (1+Profit Margin)+Shipping Cost',
    SuggestedPriceTips2: '(If you have selected "Including Shipping Cost")',
    SuggestedPriceTips3: 'Modify all prices with one click',
    SuggestedPriceTips4: 'Suggested Price = Product Cost + Profit + Shipping Cost',
    CompareAtPriceTips2: 'Compare At Price = Product Cost + Profit + Shipping Cost',
    NewPrice: 'New Price',
    cancel: 'Cancel',
    confirm: 'Confirm',
    Percentage: 'Percentage',
    OneClickModification: 'One-Click Modification',
    FixedProfit: 'Fixed Profit',
    ProductionEditor: 'Product Editor',
    SyncCollection: 'Sync Collection',
    selectContent: 'Select Content',
    ShippingFrom: 'Shipping From',
    ShippingTo: 'Shipping To',
    EstimatedDeliveryTime: 'Estimated Delivery Time',
    NoPictures: 'No Pictures',
    loadingText: 'Loading...',
    repeat: 'Repeat!',
    IncorrectLogisticsInformation: "Shipping Method can't be empty",
    PictureCannotBeEmpty: 'Picture Cannot Be Empty',
    SKUCannotBeEmpty: 'SKU Cannot Be Empty',
    inputLength: 'Length Less Than 255',
    richTextCheck: 'The number of rich text words cannot exceed 40000',
    CompareAtPriceCheck: 'The compare at price must be higher than the suggested price',
    CompareAtPriceCheckShoplazza: 'The price comparison must be higher than',
    titleCheck: "title can't be empty",
    DescriptionCheck: "Description can't be empty",
    ShelfStatusUp: 'The product will be available in the store early',
    ShelfStatusDowm: 'This product was previously listed to the store.',
    ProfitMargin: 'Profit Margin',
    imageMaxLengthTips: 'You can only select up to 250 pictures',
    imageMaxLengthTips2: 'You can only select up to 40 pictures',
    tagLength: 'Set up to 10 labels',
    isFilterDuplicateSpuText: 'The same product will be listed repeatedly',
    beenListed: 'Failed. Items have already been listed.',
    tips6: 'Variant product SKU cannot be empty.',
    tips7: 'publish Tips',
    LogisticsError: 'Failed to obtain logistics, please contact our customer service team',
    tips8: 'Select up to nine images',
    categoryIdCheck: 'Please select a category',
    tips9: 'There is a change in Kaka product information, click ”Update” to get the latest change information.',
    Update: 'Update',
    optionEmptyTip: 'option cannot be empty'
  },
  publishListings: {
    listings: 'Listings',
    Published: 'Published',
    Active: 'Active',
    Hidden: 'Hidden',
    Update: 'Update',
    Deactivate: 'Deactivate',
    Inactive: 'Inactive',
    Suspended: 'Suspended',
    Reviewing: 'Reviewing',
    Failed: 'Failed',
    Frozen: 'Frozen',
    WaitingForUpdate: 'Waiting For Update',
    ListingQueue: 'Listing Queue',
    Deleted: 'Deleted',
    productSelected: 'Product Selected',
    Product: 'Product',
    ProductId: 'Product Id',
    priceScope: 'Price Scope',
    CompareAtPrice: 'Compare At Price',
    Inventory: 'Inventory',
    EditProduct: 'Edit Product',
    More: 'More',
    Synchronous: 'Synchronous',
    Relist: 'Re-List',
    Activate: 'Activate',
    PublishedIn: 'Published In ...',
    Delete: 'Delete',
    synType1Title: 'On Listing...',
    synType5Title: 'On Relisting...',
    synType5TitleTT: 'On Activateing...',
    synType4Title: 'Being Hidden From Store...',
    synType4TitleTT: 'Being Deactivate From Store...',
    synType10Title: 'In Sync...',
    synType2Title: 'Editing Information In Sync...',
    noProduct: 'Sorry, You have not added a product',
    ChooseProduct: 'Choose Product',
    ConnectANewStore: 'Connect A New Store',
    hiddenComfirmTitle: 'Are you sure to off shelf the product from store',
    RelistComfirmTitle: 'Are you sure to relist the product to the store?',
    deleteComfirmTitle: 'Are you sure you want to delete the product from your store?',
    synType3Title: 'Delete the...',
    searchBy: 'Search content',
    SelectStore: 'Select Store',
    store: 'Store',
    productName: 'Product name',
    available: 'Available',
    soldOut: 'Out of Stock',
    notAvailable: 'Not available',
    emptyTips1: 'Your order listings is empty!',
    emptyTips2: 'You can manage and process your listings here',
    createProduct: 'Create product'
  },
  productList: {
    wishList: 'Favorite Item',
    productList: 'Product List',
    Delete: 'Delete',
    productSelected: 'Product Selected',
    deleteTip1: 'Are you sure to remove the checked product?',
    submit: 'Submit',
    cancel: 'Cancel',
    Description: 'Description',
    Inventory: 'Inventory',
    Price: 'Price',
    ProductType: 'Product Type',
    Action: 'Action',
    Detail: 'Detail',
    more: 'More',
    ListToStore: 'List To Store',
    customized: 'Customized',
    goodsInStock: 'In Stock',
    statusTips: 'The product is unavailable.',
    canFind: "Sorry, can't find~ Please search again",
    ItemNo: 'Item No',
    contentPlaceholder: 'Please enter the product keyword',
    Listing: 'Listing',
    YourPrice: 'Your Price',
    From: 'From',
    ShipTo: 'Ship To',
    Cancel: 'Cancel',
    ListNow: 'List Now',
    Platform: 'Platform',
    Store: 'Store',
    ShipMyOdersMostTo: 'Ship My Oder(s) Most to',
    ShippingMethod: 'Shipping Method',
    logisticsTips: 'As long as you select one of the shipping place, receiving place and logistics channel, you must select all of them',
    batchPublishTips: 'Upload a maximum of 100 listings at once',
    storeTips: 'Can only be uploaded to 1 store at a time',
    priceTips: 'Should includes the KakaClo price ,shipping costs.taxes and your profit',
    shipTips: 'The selected logistics mode is only used as the logistics supported by the system',
    ShippingMethodTips: 'Optional (you’re able to tweak it before shipment starts)',
    inputPlaceholder: 'Search content',
    haveShelves: 'List Failed : Unavailabe items included.',
    textareaPlaceholder: 'Separate multiple searches with commas or newlines',
    repeatListTip: ' The same product will be listed repeatedly',
    repeatList: 'repeat list',
    priceRatioGT20Tip: 'The product you upload will be uploaded at 20 times the sales price',
    yourPrice: 'Your price',
    Status: 'Status',
    selectProductStatus: 'Select product status',
    selectPublishStatus: 'Select publish status',
    removeSelectedProducts: 'Remove selected products',
    removeunavailableProducts: 'Remove Unavailable products',
    Tips1: 'Are you sure you want to remove all Unavailable/Out of Stock product?',
    Tips2: 'Please select product first.'
  },
  batchTasks: {
    batchTasks: 'Batch Tasks',
    Status: 'Status',
    contentPlaceholder: 'searching for',
    Number: 'Number',
    StoreInformation: 'Store Information',
    ItemNo: 'Item No',
    PublicationSituation: 'Publication situation',
    FailedToLoad: 'Failed to load',
    Success: 'Success',
    uploading: 'uploading',
    ListingFailed: 'Listing failed',
    CreationTime: 'Creation Time',
    Pending: 'Pending',
    Processing: 'Processing',
    Completed: 'Completed',
    contentPlaceholder2: 'searching for item no',
    Platform: 'Platform',
    Store: 'Store',
    Product: 'Product',
    ReasonForFailure: 'Reason for failure',
    data: 'data'
  },
  Publish: {
    ProductList: {
      Index: {
        ListingQueue: 'Listing Queue',
        Published: 'Published'
      },
      Components: {
        MTList: {
          SelectAll: 'Select All',
          Price: 'Price',
          Inventory: 'Inventory',
          Delete: 'Delete',
          ListToStore: 'List To Store',
          FavoriteItem: 'Sorry, you have not added a product',
          ListItem: 'Your listing is empty',
          ListItem1: 'You can manage and process your listings here',
          ChooseProduct: 'Choose Product',
          NewStore: 'Connect a New Store'
        },
        BatchListToStoreModal: {
          Update: 'Update',
          SuggestedPrice: 'Suggested Price',
          Multiplier: 'Multiplier',
          ShippingCost: 'shipping Cost',
          CompareAtPrice: 'Compare at Price',
          Tips1: 'Compare at Price has to greater than Suggested Price',
          Tips2: 'For items that have already been listed',
          Skip: 'Skip',
          Duplicate: 'Duplicate',
          Listing: 'Listing',
          SizeUnit: 'Size Unit',
          Platform: 'Platform',
          Store: 'Store',
          Collection: 'Collection',
          Categorys: 'Categorys',
          Tags: 'Tags',
          SugestPrice: 'Suggested Price',
          Explain: 'If the title, description, size, variant, or picture of the Kaka product associated with your selected listing are updated, the latest changes will be automatically synchronized with your store.',
          SPExplain: 'The listing you selected will be updated based on the information you set in the kaka store.'
        }
      }
    },
    Listings: {
      Components: {
        TableList: {
          Authorization: 'Authorization',
          Expires: 'expires',
          Tips1: 'Product has been removed from',
          ReList: 'Re-list',
          Tips2: 'View at "Deleted"',
          NoExist: 'No Exist'
        },
        MTList: {
          SelectAll: 'Select All',
          ProductId: 'Product Id',
          ProductCoat: 'Product Coat',
          Inventory: 'Inventory',
          Delete: 'Delete',
          Hidden: 'Hidden',
          Published: 'Published',
          Deleted: 'Deleted',
          ListingQueue: 'ListingQueue'
        },
        MTDetail: {
          Listing: 'Listing',
          Tips1: 'Editing product information is only supported on the computer version',
          ProductId: 'Product Id',
          ProductCoat: 'Product Coat',
          Inventory: 'Inventory',
          ProductCost: 'Product cost'
        }
      }
    },
    Edit: {
      Index: {
        SizeUnit: 'Size Unit',
        Description: 'Description',
        Variants: 'Variants',
        Images: 'Images'
      },
      Components: {
        Variants: {
          SuggestedPrice: 'SuggestedPrice',
          CompareAtPrice: 'CompareAtPrice'
        },
        TopInfo: {
          Update: 'Update',
          Categorys: 'Categorys',
          PoductsType: 'Poducts type',
          NewTag: 'New Tag',
          SelectTags: 'select tags',
          Published: 'Published',
          Hidden: 'Hidden'
        },
        ImageList: {
          MediaSelected: 'media selected'
        }
      }
    },
    CustomProduct: {
      List: {
        Index: {
          CustomizeOnDemand: 'Customize on Demand',
          PrintOnDemand: 'Print on Demand'
        },
        Components: {
          PaySampleFee: {
            Others: 'Others',
            PayNow: 'Pay Now'
          },
          EmptyData: {
            Tips1: 'Submit your custom requirements'
          }
        }
      },
      Detail: {
        Index: {
          ProductName: 'Product Name',
          Material: 'Material'
        }
      }
    },
    BatchTasks: {
      Index: {
        ListingQueue: 'Listing Queue',
        Back: 'Back',
        Pending: 'pending',
        Processing: 'Processing',
        Completed: 'Completed'
      }
    }
  },
  // 我的的设计
  userDesign: {
    MyDesign: 'My Design',
    Tips1: 'Search for item No',
    ProductSelected: 'Product Selected',
    ItemNo: 'Item No',
    Price: 'Price',
    DesignTime: 'Design Time',
    Action: 'Action',
    Actions: 'Actions',
    Detail: 'Detail',
    Remove: 'Remove',
    Tips2: 'Are you sure to remove the selected product?',
    Notice: 'Notice',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    Tips3: 'Print On Demand uses a process of 3D thermal transfer, so modifying the color of the garment only modifies the color of the outer layer, and the inner layer is always white.'
  }
}
